import { Button, Grow } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  selectCompanyAddress,
  selectDefultProfileSetting,
  selectUserType,
} from "../utility/Redux/profile";
import { selectToken } from "../utility/Redux/security";
import { decodeToken } from "../utility/constant";
import { buttonCard } from "../reports/dashboard";
import { privateRoutes } from "../route";

const AccountsPage = () => {
  const navigation = useNavigate();
  const usertype = useSelector(selectUserType);
  const defaultSetting = useSelector(selectDefultProfileSetting);
  const token = useSelector(selectToken);
  const user_module = decodeToken(token)?.user_modules || "default";
  const user_modules = user_module.split(",");
  const [list, setList] = useState([
    {
      name: "Account Master",
      path: "/account_master",
      userType: "ADMIN MANAGER",
      onclick: () => {
        navigation("/account_master");
      },
    },
    {
      name: "Balance Sheet Head Master",
      path: "/bal_sheet_head_master",
      userType: "ADMIN MANAGER",
      onclick: () => {
        navigation("/bal_sheet_head_master");
      },
    },
    {
      name: "Trial Balance - Under Group Wise",
      path: "/trial_balance_under_group_wise",
      userType: "ADMIN MANAGER",
      onclick: () => {
        navigation("/trial_balance_under_group_wise");
      },
    },
    {
      name: "Trial Balance - Account Head Wise",
      path: "/trial_balance_account_head_wise",
      userType: "ADMIN MANAGER",
      onclick: () => {
        navigation("/trial_balance_account_head_wise");
      },
    },
    {
      name: "Trial Balance - Opening Balance Wise",
      path: "/trial_balance_opening_balance_wise",
      userType: "ADMIN MANAGER",
      onclick: () => {
        navigation("/trial_balance_opening_balance_wise");
      },
    },
    {
      name: "Account Ledger",
      path: "/account_ledger",
      userType: "ADMIN MANAGER",
      onclick: () => {
        navigation("/account_ledger");
      },
    },
    {
      name: "Voucher Entery",
      path: "/voucher_entery",
      userType: "MANAGER,USER,ADMIN,STORE",
      onclick: () => {
        navigation("/voucher_entery");
      },
    },
    {
      name: "Account Reconcillation Report",
      path: "/account_reconcillation_report",
      userType: "MANAGER,USER,ADMIN,STORE",
      onclick: () => {
        navigation("/account_reconcillation_report");
      },
    },
  ]);
  useEffect(() => {
    if (defaultSetting?.TRANSFER_PURCHASE_ACCOUNTS === "Yes") {
      setList([
        ...list,
        {
          name: "Update Purchase To Accounts",
          path: "/update_purchase_to_accounts",
          userType: "ADMIN MANAGER USER",
          onclick: () => {
            navigation("/update_purchase_to_accounts");
          },
        },
      ]);
    }
  }, []);
  const companyDetails = useSelector(selectCompanyAddress);
  const allowedList = list.filter((o) => {
    if (user_modules.find((e) => e === "default")) {
      const isAllowedInPlan = privateRoutes.filter((p) => {
        if (
          p.path === o.path &&
          p.plan_type.includes(companyDetails?.plan_type)
        ) {
          return true;
        }
      });
      if (
        o.userType.toLowerCase().includes(usertype.toLowerCase()) &&
        isAllowedInPlan[0]
      ) {
        return true;
      }
    } else {
      return user_modules.find(
        (e) => e === o.path.replace(/_/g, "-").replace(/\//g, "")
      );
    }
  });
  const userType = useSelector(selectUserType);
  return (
    <div className="h-full p-4 overflow-y-auto">
      <div className="grid grid-cols-1 sm:grid-cols-2 t:grid-cols-2 d:grid-cols-4 ll:grid-cols-5 gap-3  ">
        {allowedList[0] &&
          allowedList.map((e, i) => {
            return (
              <Grow
                key={i}
                in={true}
                style={{ transformOrigin: "0 0 0" }}
                {...(true ? { timeout: i === 0 ? 0 : i * 200 } : {})}
              >
                {buttonCard(i, e, userType)}
              </Grow>
            );
          })}
      </div>
    </div>
  );
};

export default AccountsPage;
